export const storePaymentIntent = (
  paymentIntentId: string,
  clientSecret: string,
) => {
  localStorage.setItem('payment_intent', JSON.stringify(paymentIntentId));
  localStorage.setItem(
    'payment_intent_client_secret',
    JSON.stringify(clientSecret),
  );
};
